import { render, staticRenderFns } from "./general-work-ops.vue?vue&type=template&id=677a9de0&scoped=true"
import script from "./general-work-ops.vue?vue&type=script&lang=js"
export * from "./general-work-ops.vue?vue&type=script&lang=js"
import style0 from "./general-work-ops.vue?vue&type=style&index=0&id=677a9de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a9de0",
  null
  
)

export default component.exports